import React, { useContext } from 'react';
import { useSubjectContext } from './index';
import { PageWrapper } from '../../components/styled/styles';
import { Typography } from '@dls/react-core';
import { SubjectForm } from '../../components/subjects/subject-form';
import { Subject, updateSubject } from '../../api/studykit';
import { StudyPageContext } from '../../App';
import { useSnackbar } from 'notistack';
import { NotiStackAction } from '../../components/styled/notistack-action';
import { Grid } from '@material-ui/core';
import { ReactNode } from 'react';
import styled from 'styled-components';
import { format } from 'date-fns';
import { useAuthorization } from '../../context/authorization';
import { AsyncSubmitHandler } from '../../helpers/form-error-handling';

export const PersonalDetails = () => {
  const { subject } = useSubjectContext();
  const { study } = useContext(StudyPageContext);
  const { hasPermission } = useAuthorization();

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const onSubmit: AsyncSubmitHandler<Subject> = (data, event) => {
    event?.preventDefault();
    return updateSubject(study.id, subject.id, data).then(() => {
      enqueueSnackbar('Personal details have been successfully updated!', {
        variant: 'success',
        action: <NotiStackAction close={closeSnackbar} />,
      });
    });
  };

  const canUpdate = hasPermission('Subjects.Update');

  return (
    <PageWrapper>
      <Typography weight={'bold'} variant={'body1'}>
        Personal details overview
      </Typography>
      {canUpdate ? (
        <SubjectForm onSubmit={onSubmit} subject={subject} />
      ) : (
        <ReadonlySubjectDetails subject={subject} />
      )}
    </PageWrapper>
  );
};

const StyledFormItem = styled(Typography)`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
`;

const GridFormElement = ({ label, children }: { label: string; children: ReactNode }) => (
  <Grid item xs={12} md={6}>
    <StyledFormItem>
      <Typography weight="bold">{label}</Typography>
      {children}
    </StyledFormItem>
  </Grid>
);

export const ReadonlySubjectDetails = ({ subject }: { subject: Subject }) => {
  return (
    <Grid container spacing={3}>
      <GridFormElement label={'Name'}>{subject.name}</GridFormElement>
      <GridFormElement label={'Gender'}>{subject.gender || 'Unknown'}</GridFormElement>
      <GridFormElement label="Weight">
        {subject.weightKg ? `${subject.weightKg} kg` : 'Unknown'}
      </GridFormElement>
      <GridFormElement label={'Date of Birth'}>
        {subject.dateOfBirth ? format(new Date(subject.dateOfBirth), 'dd MMM yyyy') : 'Unknown'}
      </GridFormElement>
      <GridFormElement label="Height">
        {subject.heightCm ? `${subject.heightCm} cm` : 'Unknown'}
      </GridFormElement>
      <GridFormElement label={'Handedness'}>{subject.handedness || 'Unknown'}</GridFormElement>
      <GridFormElement label={'Start Date'}>
        {subject.startDate ? new Date(subject.startDate).toLocaleDateString() : 'Missing'}
      </GridFormElement>
      <GridFormElement label={'End Date'}>
        {subject.endDate ? new Date(subject.endDate).toLocaleDateString() : 'Missing'}
      </GridFormElement>
    </Grid>
  );
};
